(function () {
  $(function () {
    $(document)
      // CC Members 和讨论里的选择成员共用代码
      .on('click', '.notify-title span.group-select', function (e) {
        var $link = $(this);
        var groupId = $link.data('subgroup');
        var $notify = $link.closest('.notify');
        var $members = $notify.find('.member-list input:checkbox');

        if (groupId !== -1) {
          $members = $members.filter('[data-subgroup*=' + groupId + ']');
        }

        $members.prop('checked', !$link.hasClass('selected'));
        tower.refreshCCGroup($notify);
      })
  })
}());
